import { render, staticRenderFns } from "./ChargebackWarningEthoca.vue?vue&type=template&id=2f44d40a&scoped=true"
import script from "./ChargebackWarningEthoca.vue?vue&type=script&lang=js"
export * from "./ChargebackWarningEthoca.vue?vue&type=script&lang=js"
import style0 from "./ChargebackWarningEthoca.vue?vue&type=style&index=0&id=2f44d40a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f44d40a",
  null
  
)

export default component.exports